module.exports = __webpack_public_path__ + "img/talk-circle.0c02127a.png";